// Module
var code = "<div ng-if=\"vm.ngModel\" class=\"ocThumbnail\"> <span> <img ng-src=\"{{vm.thumbUrl}}\" ng-click=\"vm.onThumbClick()\" ng-style=\"{'background': vm.backgroundColour}\"/> </span> </div> ";
// Exports
module.exports = code;